/* jshint esversion: 6 */
import React from 'react';
import HelpButton from 'app/components/common/HelpButton.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

const replayPrefixConst = ['ICYMI:', 'FYI:'];

const checkPropsForRepost = function(props) {
    let replayVals = [],
        replayPrefixes = _.clone(replayPrefixConst),
        replayValue = 0,
        replayDays = 0,
        replayHours = 0;

    if (props.input && props.input.attrs && props.input.attrs.repost) {
        for (let i = 0; i < props.input.attrs.repost.length; ++i) {
            // reset values
            replayValue = replayDays = replayHours = 0;
            replayValue = parseInt(props.input.attrs.repost[i]);
            if (replayValue) {
                if (replayValue >= 1440) {
                    replayDays = Math.floor(replayValue / 1440);
                    replayValue = replayValue - (1440 * replayDays);
                }
                replayHours = replayValue / 60;
                replayVals.push([replayDays, replayHours]);
            }
        }

        // no reposts? set default
        if (replayVals.length === 0) {
            replayVals.push([1, 0]);
        }

        if (props.input.attrs.echoPrefix) {
            replayPrefixes = props.input.attrs.echoPrefix;
        }

    }

    return [replayVals, replayPrefixes];

};

class EchoComponent extends React.Component {
    constructor(props) {
        super(props);

        let replays = checkPropsForRepost(this.props);

        this.state = {
            replays: replays[0],
            echoPrefix: replays[1],
			replayError: null,
            optionsVisible: false
        };

        this.toggleReplay = this.toggleReplay.bind(this);
        this.updateReplayValue = this.updateReplayValue.bind(this);
        this.updateReplayPrefixValue = this.updateReplayPrefixValue.bind(this);
        this.updateReplayPrefix = this.updateReplayPrefix.bind(this);
        this.updateReplay = this.updateReplay.bind(this);
        this.replayControl = this.replayControl.bind(this);
        this.addSecondReplay = this.addSecondReplay.bind(this);
        this.removeReplay = this.removeReplay.bind(this);

    }


    static getDerivedStateFromProps(props, state) {

        let replayVals = [];

		if (props.input.attrs && props.input.attrs.repost) {
			replayVals = checkPropsForRepost(props);
			if (replayVals.length) {
				return {
					replays: replayVals[0],
                    echoPrefix: replayVals[1]
				};
			}
		}

        return null;

    }

    toggleReplay(e) {
		let toggleState = false,
			newValue = [],
            nextOptionsVisible = this.state.optionsVisible;

		if (e.currentTarget.dataset.togglestate) {
			toggleState = (e.currentTarget.dataset.togglestate === 'true') ? 0 : 1;
		}

		if (toggleState && !this.props.user.perms.resources.repost) {
			this.props.showUpgradeModal(this.props.closeAllModals, 'replay', this.props.errors, 'input_edit');
		} else {
			if (toggleState) {
				newValue.push(1440);
                nextOptionsVisible = true;
			} else {
                nextOptionsVisible = false;
                // reset default value even without sending to db
                this.setState({
                    replays: [[1, 0]],
                    echoPrefix: _.clone(replayPrefixConst)
                });
            }
			this.props.changeHandler({
				currentTarget: {
					dataset: {
						field: this.props.statePath + '.attrs.repost'
					}
				},
				target: {
					value: newValue
				}
			});
            this.props.changeHandler({
				currentTarget: {
					dataset: {
						field: this.props.statePath + '.attrs.echoPrefix'
					}
				},
				target: {
					value: _.clone(replayPrefixConst)
				}
			});
		}

        this.setState({
            optionsVisible: nextOptionsVisible
        });

	}

    updateReplayValue(e) {
        let field = '',
            index = 0;

        let parts = e.currentTarget.dataset.field.split("_");
        field = parts[0];
        index = parts[1];
		if (e.currentTarget.dataset.field.match('days')) {
			this.updateReplay(index, e.currentTarget.value, this.state.replays[index][1]);
			this.setState({
				replayDays: e.currentTarget.value
			});
		} else {
			this.updateReplay(index, this.state.replays[index][0], e.currentTarget.value);
			this.setState({
				replayHours: e.currentTarget.value
			});
		}

	}

    updateReplayPrefixValue() {
        let prefixes = this.state.echoPrefix;

        this.props.changeHandler({
            currentTarget: {
                dataset: {
                    field: this.props.statePath + '.attrs.echoPrefix'
                }
            },
            target: {
                value: prefixes
            }
        });
    }

    updateReplayPrefix(e) {

        let index = e.currentTarget.dataset.index,
            prefixes = this.state.echoPrefix,
            prefixError = (
                <div className="fieldset-error">
                    <ul className="fieldset-error-list">
                        <li className="error-list-item">Sorry, a prefix is required.</li>
                    </ul>
                </div>
            );

        prefixes[index] = e.currentTarget.value;

        for (let i = 0; i < prefixes.length; ++i) {
            if (prefixes[i] === '') {
                this.setState({
                    replayError: prefixError
                });
                return;
            }
        }

        this.updateReplayPrefixValue();

        this.setState({
            echoPrefix: prefixes,
            replayError: null
        });

    }

	updateReplay(index, days, hours) {
		let newValue = _.clone(this.props.input.attrs.repost) || [],
			minutes = 0,
			maxError = (
				<div className="fieldset-error">
					<ul className="fieldset-error-list">
						<li className="error-list-item">Sorry, 30 days is the longest you can wait to echo an item</li>
					</ul>
				</div>
			),
			minError = (
				<div className="fieldset-error">
					<ul className="fieldset-error-list">
						<li className="error-list-item">Sorry, you have to wait at least one day to echo an item</li>
					</ul>
				</div>
			),
            prefixError = (
                <div className="fieldset-error">
                    <ul className="fieldset-error-list">
                        <li className="error-list-item">Sorry, a prefix is required.</li>
                    </ul>
                </div>
            ),
            replayError = null,
            updateInput = function(inputAttr, updatedValue) {
                this.props.changeHandler({
                    currentTarget: {
                        dataset: {
                            field: inputAttr
                        }
                    },
                    target: {
                        value: updatedValue
                    }
                });
            }.bind(this);

        if (days === null && hours === null) {
            newValue.pop();
            updateInput(this.props.statePath + '.attrs.repost', newValue);

            return;
        }

        minutes = (parseInt(days, 10) * 1440) + (parseInt(hours, 10) * 60);

		// check if the time is greater than 31 days
		if (minutes > 44640) {
			this.setState({
				replayError: maxError
			});
			return;
		} else if (minutes < 60) {
			this.setState({
				replayError: minError
			})
			return;
		}

        if (this.state.replays.length) {
            for (let i = 0; i < this.state.echoPrefix.length; ++i) {
                if (this.state.echoPrefix[i] === '') {
                    replayError = prefixError;
                }
            }
        }

		if (typeof newValue[index] === "undefined" || newValue[index] != minutes) {
            newValue[index] = minutes;
			updateInput(this.props.statePath + '.attrs.repost', newValue);
            this.updateReplayPrefixValue();
		}

		this.setState({
			replayError: replayError
		});

	}

    replayControl(index, withDelete) {
        let replay = (this.props.input && this.props.input.attrs && this.props.input.attrs.repost && this.props.input.attrs.repost.length) ? true : false,
            replayState = 'disabled',
            days = [],
            hours = [],
            replayDelete = null,
            replayLabel = "After first post",
            prefixes = _.clone(replayPrefixConst),
            i = 0;

        if (this.state.replays.length === 0 || typeof this.state.replays[index] === "undefined") {
            return null;
        }

        if (this.props.input.attrs.echoPrefix) {
            prefixes = this.props.input.attrs.echoPrefix;
        }

        if (replay && this.props.input.attrs.echoPrefix === undefined) {
            prefixes = ['', ''];
        }

        for (i = 1; i <= 30; ++i) {
			days.push({value: i, label: i});
		}

		for (i = 0; i < 24; ++i) {
			hours.push({value: i, label: i});
		}

        if (index > 0) {
            replayLabel = "After second post";
        }

        if (replay) {
			replayState = '';
        }

        if (withDelete) {
            replayDelete = (
                <div className="inline-wrapper">
                    <div className="replay-delete" alt="Remove echo" title="Remove echo" onClick={this.removeReplay} role="button" aria-label="remove echo">
                        <i className="icon ion-close-round"></i>
                    </div>
                </div>
            );
        }

        return (
            <div className="replay-control">
                <Breakpoint desktop only>
                    <div className="inline-wrapper">
                        <div className="small-label">Day(s):</div>
                        <StyledSelect
                            options={days}
                            value={this.state.replays[index][0]}
                            selectClass="mini"
                            onChange={this.updateReplayValue}
                            controlState={replayState}
                            linkedField={"days_" + index}/>
                    </div>
                    <div className="inline-wrapper">
                        <div className="small-label">Hour(s):</div>
                        <StyledSelect
                            options={hours}
                            value={this.state.replays[index][1]}
                            selectClass="mini"
                            onChange={this.updateReplayValue}
                            controlState={replayState}
                            linkedField={"hours_" + index}/>
                    </div>
                    <div className="inline-wrapper">
                        <div className="small-label">Prefix:</div>
                        <UncontrolledTextInput type="text" disabled={replayState} className="text-input large" defaultValue={prefixes[index]} onChange={this.updateReplayPrefix} data-index={index}/>
                    </div>
                    {replayDelete}
                    <div className="replay-label">
                        {replayLabel}
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="inline-wrapper mobile">
                        <div className="small-label">Day(s):</div>
                        <StyledSelect
                            options={days}
                            value={this.state.replays[index][0]}
                            selectClass="mini"
                            onChange={this.updateReplayValue}
                            controlState={replayState}
                            linkedField={"days_" + index}/>
                    </div>
                    <div className="inline-wrapper mobile">
                        <div className="small-label">Hour(s):</div>
                        <StyledSelect
                            options={hours}
                            value={this.state.replays[index][1]}
                            selectClass="mini"
                            onChange={this.updateReplayValue}
                            controlState={replayState}
                            linkedField={"hours_" + index}/>
                    </div>
                    {replayDelete}
                    <div className="replay-label">
                        {replayLabel}
                    </div>
                    <div>
                        <div className="small-label">Prefix:</div>
                        <UncontrolledTextInput type="text" disabled={replayState} className="text-input large" defaultValue={prefixes[index]} onChange={this.updateReplayPrefix} data-index={index}/>
                    </div>
                </Breakpoint>
            </div>
        );
    }

    addSecondReplay(e) {
        let replays = this.state.replays;
        e.preventDefault();

        replays.push(replays[0]);
        this.updateReplay(1, replays[1][0], replays[1][1]);

        this.setState({
            replays: replays
        });
    }

    removeReplay(e) {
        let replays = this.state.replays;

        e.preventDefault();

        replays.pop();
        this.updateReplay(1, null, null);

        this.setState({
            replays: replays
        });

    }

    render() {
        let replay = (this.props.input && this.props.input.attrs && this.props.input.attrs.repost && this.props.input.attrs.repost.length) ? true : false,
            replayClass = 'replay-disabled',
            secondReplay = null,
            secondAction = null,
            marketing = null,
            constants = this.props.app.config.constants;

        if (replay) {
			replayClass = '';
            secondAction = this.addSecondReplay;
		}

        if (replay && this.state.replays.length <= 1) {
            secondReplay = (
                <div className="second-replay" onClick={secondAction} role="button" aria-label="add second echo">
                    + Add second echo
                </div>
            )
        } else {
            secondReplay = this.replayControl(1, true);
        }

        if (this.props.isFreeUser()) {
            marketing = (
                <div className="marketing-sticker" onClick={function(e) {
                    this.props.showUpgradeModal(this.props.closeAllModals, 'replay', this.props.errors, 'input_edit');
                }.bind(this)} role="button" aria-label="upgrade"><i className="fa fa-star-o"></i>Get more from your content</div>
            );
        }

        return (
            <fieldset>
                <legend>Echo<HelpButton which="replay"/>{marketing}</legend>
                <ErrorModule
                    app={this.props.app}
                    keys={['INPUT_UPDATE']}
                    render={(state) => {
                        return (
                            <FieldError field="name" errors={state.errors}/>
                        );
                    }}/>
                {this.state.replayError}
                <div>
                    <Toggle
                        active={replay}
                        labelPlacement="right"
                        activeLabel="Echo Content"
                        inactiveLabel="Echo Content"
                        callback={this.toggleReplay} />
                </div>
                {this.state.optionsVisible ? (
                    <div className={replayClass}>
                        <p>After dlvr.it posts an item, queue it for recycling:</p>
                        d{this.replayControl(0, false)}
                        {secondReplay}
                        <p>
                            <em>Twitter content will be retweeted in accordance with their new policies.</em>
                        </p>
                    </div>
                ) : null}

            </fieldset>
        );
    }

}

EchoComponent.displayName = "EchoComponent";

export default EchoComponent;
